import React, { useEffect } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  UncontrolledTooltip
} from 'reactstrap'
import { FaVolumeDown, FaFilePdf } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import Moment from 'moment'
import _ from 'lodash'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import CustomPagination from 'components/Pagination'
import SearchForm from 'components/SearchForm'
import PageTitle from 'components/Title/PageTitle'
import AlertNotSubscribe from 'components/Alert'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'
import Lang from 'Lang/General'
import DialogsHOC from './action'

const Dialogs = props => {

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Customer Dialogue System' })

    props.onChangeDialogsHOC('subscribedPackage', tmpIndex > -1)
    props.getSelectedSetting()
    tmpIndex > -1 && props.getDialogs(props.query)
  }, [])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Customer Dialogue System' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  useEffect(() => {
    if(!_.isEmpty(props.selectedSetting)){
      let temp = [ ... props.searchParams ]
      props.selectedSetting.dialogue_fields.map(field => {
        temp.push({
            label: field.title[props.data.languageReducer.userSettings.admin_panel_language],
            col: 4,
            value: 'info',
            param: '',
            extra: {
              dialogue_fields_id: field.id,
            }
          },)
      })

      props.onChangeDialogsHOC('searchParams', temp)
    }
  }, [props.selectedSetting])

  return (
    <>
      <PageTitle
        heading={Lang['DIALOGS'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-headphones icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          { !props.subscribedPackage && <AlertNotSubscribe { ...props } /> }
          <Row>
            <Col md={12}>
              <SearchForm
                subscribedPackage={ props.subscribedPackage }
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeDialogsHOC}
                defaultQuery={props.defaultQuery}
                getListAPI={val => {
                  props.getDialogs({
                    ... val,
                    filter: {
                      ... val.filter,
                      ... window.location.href.indexOf('archive') > -1 
                       ? {"status": "ARCHIVED"}
                       : {"status": "ACTIVE"}
                    },
                    "sort": ['-created_at']
                  })
                }}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.dialogs}
                  columns={[
                    {
                      Header: Lang['DIALOG_ID'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'encrypted_id',
                      Cell: row => (
                        <span style={{ wordBreak: 'break-all'}}>{row.original.encrypted_id.substring(0,10)}</span>
                      )
                    },
                    {
                      Header: Lang['START_DATE'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'created_at',
                      Cell: row => Moment(row.original.created_at).format('DD.MM.YYYY')
                    },
                    ... props.selectedSetting?.dialogue_fields?.[0] ? props.selectedSetting?.dialogue_fields.map(fieldChild => ({
                      ... fieldChild,
                      Header: fieldChild.title[props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: row => {
                        let temp = _.find(row.original.dialogue_fields_infos, info => info.dialogue_fields_id === fieldChild.id)
                        if (temp){
                          return <span style={{ wordBreak: 'break-all'}}>{temp.info}</span>
                        }

                        return ``
                      }
                    })) : [],
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: (row) => (
                        <>
                          {
                            window.location.href.indexOf('archive') < 0 && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2"
                                  color='primary'
                                  id={`dialog-join-${row.original.id}`}
                                  onClick={() => {
                                    props.history.push(`/dashboard/dialogs/live#${row.original.encrypted_id}`)
                                  }} >
                                  <FaVolumeDown/>
                                </Button>
                                <UncontrolledTooltip
                                  target={`dialog-join-${row.original.id}`}
                                  placement="top">
                                  { Lang[ 'JOIN' ][props.data.languageReducer.userSettings.admin_panel_language ] }
                                </UncontrolledTooltip>
                              </>
                            )
                          }
                          <Button
                            className="mb-2 mr-2 mt-2"
                            color='primary'
                            id={`dialog-pdf-${row.original.id}`}
                            onClick={() => props.downwloadPDF(row.original.encrypted_id)} >
                            <FaFilePdf />
                          </Button>
                          <UncontrolledTooltip
                            target={`dialog-pdf-${row.original.id}`}
                            placement="top">
                            PDF
                          </UncontrolledTooltip>
                          {
                            window.location.href.indexOf('archive') < 0 && (
                              <>
                                <Button
                                  className="mb-2 mt-2 btn-icon btn-icon-only"
                                  color={ 'danger' }
                                  id={`dialog-close-${row.original.id}`}
                                  onClick={() => props.onChangeDialogsHOC('selectedArchiveDialog', row.original)}>
                                  {/* { Lang[ 'CLOSE' ][props.data.languageReducer.userSettings.admin_panel_language ] } */}
                                  <AiOutlineClose />
                                </Button>
                                <UncontrolledTooltip
                                  target={`dialog-close-${row.original.id}`}
                                  placement="top">
                                  { Lang[ 'CLOSE' ][props.data.languageReducer.userSettings.admin_panel_language ] }
                                </UncontrolledTooltip>
                              </> 
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.dialogssMeta}
                  onChangePage={ val => props.getDialogs({
                    ... props.query,
                    page: val
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {props.onLoadDialogsHOC && <LoadingOverlay />}
      {
        (props.selectedArchiveDialog &&
          !_.isEmpty(props.selectedArchiveDialog)) && (
          <DeleteConfirmationModal
            title={ Lang['END_DIALOGUE'][props.data.languageReducer.userSettings.admin_panel_language]}
            handleModalClose={() => props.onChangeDialogsHOC('selectedArchiveDialog', null)}
            confirmAction={() => {
              props.closeDialog(props.selectedArchiveDialog.encrypted_id)
            }}
            content={Lang['END_DIALOGUE_CONFIRMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
            lang={props.data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }
    </>
  )
}

export default DialogsHOC(Dialogs)
